var appsettings = [
    
    /* PROD */
    {key: "user.scope", value: ["warehousedata.client"]},   
    {key: "glasschain.auth.host.addr", value: "https://gc-printergnome-auth-svc.azurewebsites.net"},
    {key: "glasschain.core.host.addr", value: "https://nabc.glasschain.net"},
    {key: "glasschain.gcid.image.base", value:  "https://gcblobstoredurable1.blob.core.windows.net/gcid"},
    {key: "version", value: "01.02.01"},
    {key: "glasschain.api.usebearertoken", value: true}



]


module.exports = {
    appsettings
}